import { useQuery, UseQueryOptions } from 'react-query'

import request from '../../config/axios'
import QueryKeys from './QueryKeys'
import { Pagination } from './types'
import { Site } from './useSitesAvailable'

export interface SiteListSearchResponse {
  sites: Site[]
  meta: Pagination
}

interface SiteSearchParams {
  filter: string
  search: string
  page?: number
  perPage?: number
}

const useSiteSearch = (
  { filter, search, page = 1, perPage = 20 }: SiteSearchParams,
  extraOptions: UseQueryOptions<SiteListSearchResponse> = {},
) => {
  const key = QueryKeys.sitesSearch({
    filter,
    search,
    page,
    perPage,
  })
  const url = `/impacts/sites/search`

  return useQuery(
    key,
    () =>
      request
        .post<SiteListSearchResponse>(url, {
          filter,
          search,
          page,
          perPage,
        })
        .then((r) => r.data),
    {
      keepPreviousData: true,
      ...extraOptions,
    },
  )
}

export default useSiteSearch
